import React, {
  useState,
  useEffect,
  useRef,
  Suspense,
  useCallback,
  useContext,
} from "react";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min.js";
import {
  addProjectTask,
  deleteTask,
  addTaskDoc,
  getProjectTaskList,
  TaskAddComment,
  TaskCommentList,
  TaskDocDelete,
  moveTOSprintTask,
  getProjectList,
} from "./Service/TaskService.js";
import { GetMasterTypeData, uploadDoc } from "../../../Services/Global-Services/GlobalServices.js";
import { getEmployeeList } from "../EmployeeList/Service/employeeService.js";
import { MultiSelect } from "primereact/multiselect";
import { LazyImage } from "../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding.js";
import AddTask from "./Add-Task.jsx";
import UploadFile_KEYS from "../../../Services/Global-Services/UploadFile_Keys.js";
import { uploadDocFile } from "../Documents/DocumentService.js";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader.jsx";
import { Link } from "react-router-dom/cjs/react-router-dom.js";
import { TostMsg } from "../../../App.js";
import { AutoComplete } from "primereact/autocomplete";
import { Editor } from "primereact/editor";
import { getRawPermissionsArray } from "../../../Routes/AuthGard/usePermissions.js";

const TashManagementTaskDetails = () => {
  const { id } = useParams();
  const history = useHistory();
  const [taskList, setTaskList] = useState({});
  const [taskHistoryData, setTaskHistoryData] = useState([]);
  const [taskStatusType, setTaskStatusType] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [employeDetails, setEmployeDetails] = useState([]);
  const [selectedAssingToName, setSelectedAssingToName] = useState(null);
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [delConfirmOpen, setDelConfirmOpen] = useState(false);
  const [qaOpen, setQaOpen] = useState(false);
  const [newComment, setNewComment] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [detailPageMode, setDetailPageMode] = useState(true);
  const [editTaskDetails, setEditTaskDetails] = useState({});
  const [parentId, setParentId] = useState(0);
  const [subTaskProjectId, setProjectId] = useState(0);
  const [taskCopy, setTaskCopy] = useState(false);
  const [subTaskList, setSubTaskList] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const toster = useContext(TostMsg);
  const [isDragging, setIsDragging] = useState(false);
  const [isDescExpanded, setIsDescExpanded] = useState(false);
  const DESC_CHAR_LIMIT = 300;
  const PREVIEW_CHAR_LIMIT = 220;
  const getPlainText = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html || "";
    return div.textContent || div.innerText || "";
  };

  const [isSprintModal, setIsSprintModal] = useState(false);
  const [moveSprint, setMoveSprint] = useState(null);
  const [sprintDropdownTaskId, setSprintDropdownTaskId] = useState(null);
  const [selectedProjectData, setSelectedProjectData] = useState(null);
  const [allProject, setAllProject] = useState([]);

  const [createProject, setCreateProject] = useState(false);
  let userPermissions = getRawPermissionsArray();


  const permissionList = () => {
    if (userPermissions) {
      userPermissions?.map((UserPermission) => {
        if (UserPermission?.PermissionName === "Project.Create") setCreateProject(true);
      });
    }
  };

  // ─── INIT: parallel calls, only once when id changes ────────────────────────
  useEffect(() => {
    if (!id) return;
    Promise.all([
      getTaskDetail(),
      getMasterTaskStatusCategory(),
      GetMasterSystemAlertList(),
    ]);
  }, [id]);

  // ─── fetch employees only when ProjectId is known ───────────────────────────
  useEffect(() => {
    if (!taskList?.ProjectId) return;
    fetchEmployeeIdData(taskList.ProjectId);
    allProjects();
    permissionList();
  }, [taskList?.ProjectId]);

  // ─── set assignee only after both task + employees are ready ────────────────
  useEffect(() => {
    if (!taskList?.AssignedToId || employeDetails.length === 0) return;

    const selectedEmp = employeDetails.find(
      (emp) => emp.Id === taskList.AssignedToId
    );

    if (selectedEmp) {
      setSelectedAssingToName(selectedEmp);
      setFilteredEmployees(employeDetails);
    } else if (taskList?.AssignToName) {
      setSelectedAssingToName({
        Id: taskList.AssignedToId,
        FullName: taskList.AssignToName,
      });
    }
  }, [taskList?.AssignedToId, employeDetails]);

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      }
    });
  }, []);

  const searchEmployee = (event) => {
    const query = event.query?.trim().toLowerCase() || "";
    const filtered = employeDetails.filter((emp) =>
      emp.FullName?.toLowerCase().includes(query)
    );
    setFilteredEmployees(query ? filtered : employeDetails);
  };

  // ==================== API CALLS ====================

  async function getTaskDetail() {
    setIsLoading(true);
    const params = {
      OrgId: userDetails?.OrgId || 101,
      LoggedInEmpId: userDetails?.EmpId || 101,
      RaisedByEmpId: "",
      AssignedToId: "",
      TaskId: 0,
      StatusId: "",
      ModuleId: "",
      SubModuleId: "",
      PriorityId: "",
      SeverityId: "",
      Search: "",
      FilterStartDate: "",
      FilterEndDate: "",
      PageNumber: 1,
      PageSize: 1,
      IsDeleted: 0,
      SprintId: 0,
      TaskNumber: "",
      TaskGUID: id,
      ProjectId: "",
      ParentTaskId: 0,
      TaskTypeId: "",
      SegmentId: "",
      SortBy: "",
      SortOrder: "ASC",
    };
    try {
      const data = await getProjectTaskList(params);
      const task = data?.Data?.OrgEmpTasks?.[0] || data?.Data || {};
      setTaskList(task);
      setTaskHistoryData(task?.TaskHistory || []);
      setSelectedStatus(task.StatusId || "");
      if (task?.Id != null) {
        await Promise.all([
          CommentList(task.Id),
          getSubTaskList(task.Id),
        ]);
      }

    } catch (error) {
      toster.current.error(error.response.Data?.Message || "somthing went wrong");
    } finally {
      setIsLoading(false);
    }
  }

  async function getSubTaskList(taskId) {
    const params = {
      OrgId: userDetails?.OrgId || 101,
      LoggedInEmpId: userDetails?.EmpId || 101,
      RaisedByEmpId: "",
      AssignedToId: "",
      TaskId: 0,
      StatusId: "",
      ModuleId: "",
      SubModuleId: "",
      PriorityId: "",
      SeverityId: "",
      Search: "",
      FilterStartDate: "",
      FilterEndDate: "",
      PageNumber: 1,
      PageSize: 1,
      IsDeleted: 0,
      SprintId: 0,
      TaskNumber: "",
      TaskGUID: "",
      ProjectId: "",
      ParentTaskId: taskId,
      TaskTypeId: "",
      SegmentId: "",
      SortBy: "",
      SortOrder: "ASC",
    };
    try {
      const data = await getProjectTaskList(params);
      const task = data?.Data?.OrgEmpTasks || [];
      setSubTaskList(task);
    } catch (error) {
      toster.current.error(error.response.Data?.Message || "somthing went wrong");
    }
  }

  async function getMasterTaskStatusCategory() {
    try {
      const data = await GetMasterTypeData({
        organisationId: userDetails?.OrgId,
        masterType: "TaskStatus",
      });
      setTaskStatusType(data?.Data || []);
    } catch (error) {
      toster.current.error(error.data.Data?.Message || "somthing went wrong");
    }
  }

  async function fetchEmployeeIdData(projectId) {
    try {
      const params = {
        OrganisationId: userDetails?.OrgId,
        LoggedInEmployeeId: userDetails?.EmpId,
        IsDirectReportOrHierarchy: 0,
        SearchText: "",
        FollowersOnly: 0,
        FollowingsOnly: 0,
        IsExEmployeesAlso: 0,
        pageNumber: 1,
        pageSize: 10000,
        EmployeeId: 0,
        IsSuggestedOnly: 0,
        ZoneId: 0,
        RegionId: 0,
        ProjectId: Number(projectId) || 0,
      };

      const employeesList = await getEmployeeList(params);
      const employeesData = employeesList.Data || [];
      setEmployeDetails(employeesData);
      setFilteredEmployees(employeesData);
    } catch (error) {
      toster.current.error(error.employeesList?.Data?.Message || "somthing went wrong");
    }
  }

  // ==================== STATUS UPDATE ====================
  const handleStatusUpdate = async (selectedStatusId) => {
    setIsLoading(true);
    if (selectedStatusId === 0) return;
    const body = {
      Id: taskList.Id,
      ProjectId: Number(taskList.ProjectId),
      TaskTitle: taskList.TaskTitle,
      TaskDescription: taskList.TaskDescription || "",
      AssignedToId: Number(taskList.AssignedToId),
      ReporterId: Number(taskList.ReporterId),
      TaskTypeId: Number(taskList.TaskTypeId),
      PriorityId: Number(taskList.PriorityId),
      SeverityId: Number(taskList.SeverityId),
      StatusId: Number(selectedStatusId),
      ModuleId: Number(taskList.ModuleId),
      SubModuleId: Number(taskList.SubModuleId),
      SegmentId: Number(taskList.SegmentId),
      DueDate: taskList.DueDate?.split(" ")[0] || "",
      EstimatedHours: Number(taskList.EstimatedHours || 0),
      Comment: "",
    };
    try {
      const response = await addProjectTask(body);
      if (response?.StatusCode === 2000) {
        toster.current.success("Task status updated successfully");
        await getTaskDetail();
      }
    } catch (err) {
      toster.current.error(err.response.Data?.Message || "somthing went wrong");

    } finally {
      setIsLoading(false);
    }
  };

  // ==================== ASSIGN UPDATE ====================
  const handleAssignUpdate = async (assignedvalue) => {
    if (assignedvalue === 0) return;
    setIsLoading(true);
    const body = {
      Id: taskList.Id,
      ProjectId: Number(taskList.ProjectId),
      TaskTitle: taskList.TaskTitle,
      TaskDescription: taskList.TaskDescription || "",
      AssignedToId: Number(assignedvalue || taskList.AssignedToId),
      ReporterId: Number(taskList.ReporterId),
      TaskTypeId: Number(taskList.TaskTypeId),
      PriorityId: Number(taskList.PriorityId),
      SeverityId: Number(taskList.SeverityId),
      StatusId: Number(taskList.StatusId),
      ModuleId: Number(taskList.ModuleId),
      SubModuleId: Number(taskList.SubModuleId),
      SegmentId: Number(taskList.SegmentId),
      DueDate: taskList.DueDate?.split(" ")[0] || "",
      EstimatedHours: Number(taskList.EstimatedHours || 0),
      Comment: "",
    };
    try {
      const response = await addProjectTask(body);
      if (response?.StatusCode === 2000) {
        toster.current.success("Task assigned successfully");
        await getTaskDetail();
      } else {
        toster.current.error("Something went worng. Please try again.");
      }
    } catch (err) {
      toster.current.error("Something went worng. Please try again.");
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  async function AddComment() {
    const params = {
      TaskId: taskList.Id,
      Comment: newComment,
    };
    setIsLoading(true);
    try {
      const response = await TaskAddComment(params);
      if (response?.StatusCode === 2000) {
        setNewComment("");
        toster.current.success(response.Data?.Message || "Comment added successfully.");
        CommentList(taskList.Id);
      }
    } catch (error) {
      toster.current.error(error.response.Data?.Message || "somthing went wrong");
    } finally {
      setIsLoading(false);
    }
  }

  const [commentList, setCommentList] = useState([]);
  async function CommentList(taskId) {
    const params = {
      TaskId: taskId,
    };
    try {
      const response = await TaskCommentList(params);
      if (response?.StatusCode === 2000) {
        setCommentList(response?.Data);
        setNewComment("");
      }
    } catch (error) {
      toster.current.error(error.response.Data?.Message || "somthing went wrong");
    }
  }

  // ==================== HELPERS ====================
  const fmtDate = (dateStr) => {
    if (!dateStr) return "—";
    return new Date(dateStr).toLocaleDateString("en-IN", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  };

  const tBadge = (type) =>
    ({
      Bug: "badge-red",
      Feature: "badge-blue",
      Enhancement: "badge-green",
      Task: "badge-amber",
      Story: "badge-purple",
      Epic: "badge-indigo",
      Hotfix: "badge-orange",
      Improvement: "badge-teal",
      Support: "badge-slate",
      Research: "badge-cyan",
    })[type] || "badge-gray";

  const segBadge = (seg) =>
    ({
      Web: "badge-blue",
      Frontend: "badge-blue",
      Backend: "badge-amber",
      iOS: "badge-purple",
      Android: "badge-emerald",
      Mobile: "badge-purple",
      Desktop: "badge-slate",
      API: "badge-orange",
      Database: "badge-teal",
      DevOps: "badge-cyan",
      QA: "badge-yellow",
    })[seg] || "badge-gray";

  const sBadge = (status) =>
    ({
      Open: "badge-gray",
      "In Progress": "badge-amber",
      Review: "badge-blue",
      Testing: "badge-cyan",
      Resolved: "badge-green",
      Done: "badge-green",
      Closed: "badge-slate",
      Reopened: "badge-orange",
      Blocked: "badge-red",
      "On Hold": "badge-yellow",
      Cancelled: "badge-red",
    })[status] || "badge-gray";

  const pBadge = (pri) =>
    ({
      Critical: "badge-red",
      High: "badge-orange",
      Medium: "badge-yellow",
      Low: "badge-green",
      Lowest: "badge-teal",
    })[pri] || "badge-gray";

  const isOverdue =
    taskList.DueDate &&
    new Date(taskList.DueDate) < new Date() &&
    !["Closed", "Resolved"].includes(taskList.StatusName);

  const STATUSES = ["Open", "In Progress", "Review", "Resolved", "Closed"];
  const STATUS_ALIAS = { Done: "Resolved" };
  const normalizedStatus = STATUS_ALIAS[taskList.StatusName] || taskList.StatusName;

  const ICONS = [
    "fa-circle-dot",
    "fa-spinner",
    "fa-magnifying-glass",
    "fa-circle-check",
    "fa-lock",
  ];
  const curIdx = STATUSES.indexOf(normalizedStatus);

  const employeeOptionTemplate = (option) => {
    if (!option) return null;
    return (
      <div className="flex align-items-center gap-2 ticket-file-attach__items_detail">
        <LazyImage
          alt={option?.FullName || "User"}
          src={option?.ProfileImage || "/images/placeholder_profile.png"}
          width="32"
        />
        <span>{option?.FullName || "Unknown"}</span>
      </div>
    );
  };

  const [deleteDocId, setDeleteDocId] = useState(0);
  const [deletedTaskId, setDeletedTaskId] = useState(0);
  const [docPathUrl, setDocPathUrl] = useState("");
  const [uploadFile, setUploadFile] = useState(false);
  const [deleteDocPopup, setDeleteDocPopup] = useState(false);

  // ==================== ATTACHMENTS ====================

  const handleFileChangeDoc = (event, type) => {
    const files = event.target.files;
    const fileArray = Array.from(files);
    if (fileArray.length > 0) {
      uploadFolderDocFile(fileArray);
    }
  };

  async function uploadFolderDocFile(file) {
    setIsLoading(true);
    if (file) {
      const formData = new FormData();
      for (let i = 0; i < file.length; i++) {
        formData.append("files", file[i]);
      }
      let params = {
        UploadType: UploadFile_KEYS?.Project,
        RefId: 0,
      };
      try {
        const response = await uploadDoc(params, formData)//uploadDocFile(params, formData);
        const data = await response;
        const docPathURL = data?.Data;
        console.log("docPathURL", docPathURL);
        setDocPathUrl(docPathURL[0]);
      } catch (error) {
        toster.current.error(error.response.Data?.Message || "somthing went wrong");
      } finally {
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
    }
  }

  async function taskAttachmentAdd() {
    const params = {
      TaskId: taskList?.Id,
      DocPath: docPathUrl,
    };
    setIsLoading(true);
    try {
      const response = await addTaskDoc(params);
      if (response?.StatusCode === 2000) {
        setUploadFile(false);
        setDocPathUrl("");
        getTaskDetail();
        GetMasterSystemAlertList("Project_FileUpload", 0);
      } else {
        toster.current.error("Something went wrong. Please try again.");
      }
    } catch (error) {
      toster.current.error(error.response.Data?.Message || "somthing went wrong");
    } finally {
      setIsLoading(false);
    }
  }

  async function taskDelete() {
    let body = { Id: deletedTaskId };
    setIsLoading(true);
    try {
      if (deletedTaskId) {
        let response = await deleteTask(body);
        if (response?.StatusCode === 2000) {
          GetMasterSystemAlertList("Task_Delete", 0);
          setDelConfirmOpen(false);
          setDeletedTaskId(0);
        }
      }
    } catch (error) {
      toster.current.error(error.response.Data?.Message || "somthing went wrong");
    } finally {
      setIsLoading(false);
    }
  }

  const handleDeleteAttachment = async () => {
    const params = {
      DocId: deleteDocId,
      TaskId: taskList?.Id,
    };
    setIsLoading(true);
    try {
      const response = await TaskDocDelete(params);
      if (response?.StatusCode === 2000) {
        toster.current.success("Task doc deleted successfully.");
        setDeleteDocId(0);
        setDeleteDocPopup(false);
        await getTaskDetail();
      }
    } catch (error) {
      toster.current.error(error.response.Data?.Message || "somthing went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  const onClosePopup = (e) => {
    setModalOpen(false);
    setEditTaskDetails({});
    setParentId(0);
    setProjectId(0);
    setTaskCopy(false);
    if (e === "success") {
      getTaskDetail();
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const files = Array.from(e.dataTransfer.files);
    if (files.length > 0) uploadFolderDocFile(files);
  };

  async function sendMoveSprint() {
    const params = {
      ProjectId: Number(moveSprint?.ProjectId || 0),
      TaskId: Number(moveSprint?.Id || 0),
      SourceSprintId: Number(moveSprint?.SprintId || 0),
      TargetSprintId: Number(moveSprint?.targetSprint?.Id || 0),
    };
    setIsLoading(true);
    try {
      const response = await moveTOSprintTask(params);
      setIsSprintModal(false);
      getTaskDetail();
      const msg =
        response?.Message ||
        response?.Data?.Message ||
        "Task moved successfully";
      toster.current.success(msg);
    } catch (error) {
      toster.current.error(
        error?.response?.Message || "Something went wrong"
      );
    } finally {
      setIsLoading(false);
    }
  }


  async function allProjects() {
    let body = {
      Id: taskList?.ProjectId,
      StartDate: "",
      EndDate: "",
      ProjectStatusId: "",
      PageNumber: 1,
      PageSize: 1000,
      Search: "",
      ProjectTypeId: "",
      ClientId: "",
      SortBy: "",
      SortOrder: "",
    };

    try {
      let res = await getProjectList(body);
      const projectList = res?.Data?.ProjectList || [];
      const normalizedProjects = projectList.map((project) => ({
        ...project,
        Id: project?.Id ?? project?.ProjectId ?? 0,
        ProjectId: project?.ProjectId ?? project?.Id ?? 0,
        GUID: (
          project?.GUID ??
          project?.Guid ??
          project?.ProjectGUID ??
          project?.ProjectGuid ??
          ""
        )
          .toString()
          .toLowerCase(),
      }));
      console.log("Normalized Projects:", normalizedProjects);
      setAllProject(normalizedProjects);
      return normalizedProjects;
    } catch (error) {
      toster.current.error(error.res.Data?.Message || "somthing went wrong"); return [];
    }
  }

  return (
    <div className="">
      <div className="task-top-pane">
        <i class="fa fa-thumb-tack i-ico" aria-hidden="true"></i>
        <div className="task-top-pane-title">
          <h4>Welcome to OrgGenie</h4>
          <p>Manage your tasks, projects, and workspaces in one place.</p>

        </div>
      </div>
      <div className="tm-main-area">
        <div className="page">
          <div className="flex" style={{ flex: 1, overflow: "hidden" }}>
            <div
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                overflowY: "scroll",
                height: "calc(100vh - 13vh)",
              }}
            >
              {/* TASK HEADER */}
              <div className="card mb14" style={{ padding: "16px 18px" }}>
                <div
                  className="flex ic gap10"
                  style={{ alignItems: "flex-start" }}
                >
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div className="actions-status-inline">
                      <span className="code">
                        <code>
                          {taskList?.TaskNumber || "—"}
                        </code>
                      </span>
                      <span className={`badge ${tBadge(taskList?.TaskTypeName)}`}>
                        {taskList?.TaskTypeName || "N/A"}{" "}
                      </span>
                      <span className={`badge ${segBadge(taskList?.SegmentName)}`}>
                        {taskList?.SegmentName || "N/A"}{" "}
                      </span>
                      <span className={`badge ${sBadge(taskList?.StatusName)}`}>
                        {taskList?.StatusName || "N/A"}{" "}
                      </span>
                      <span className={`badge ${pBadge(taskList?.PriorityName)}`}>
                        {taskList?.PriorityName || "N/A"}{" "}
                      </span>
                      <span className="badge badge-red">
                        {taskList?.SeverityName || "N/A"}{" "}
                      </span>
                    </div>

                    <h2 className="task-detail-title">
                      {taskList?.TaskTitle || "No data found"}
                      {taskList?.ParentTaskId !== 0 && (
                        <svg
                          // title={task?.ParentTaskNumber}
                          xmlns="http://w3.org"
                          viewBox="0 0 24 24"
                          width="16"
                          height="16"
                          style={{ marginLeft: "6px", flexShrink: 0 }}
                        > <title>{taskList?.ParentTaskNumber}</title>
                          <rect
                            x="3"
                            y="3"
                            width="6"
                            height="6"
                            rx="1.5"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linejoin="round"
                          />
                          <line
                            x1="12"
                            y1="5"
                            x2="21"
                            y2="5"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                          />
                          <line
                            x1="12"
                            y1="8"
                            x2="18"
                            y2="8"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                          />
                          <path
                            d="M6 10v6h4"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <rect
                            x="12"
                            y="13"
                            width="6"
                            height="6"
                            rx="1"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linejoin="round"
                          />
                          <line
                            x1="20"
                            y1="15"
                            x2="21"
                            y2="15"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                          />
                          <line
                            x1="20"
                            y1="18"
                            x2="21"
                            y2="18"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                          />
                        </svg>
                      )}
                    </h2>


                    <div
                      className="flex ic gap14 text-muted"
                      style={{ fontSize: "12px", flexWrap: "wrap", gap: "12px" }}
                    >
                      <span>
                        <i
                          className="fa-solid fa-folder"
                          style={{ marginRight: "3px", color: "var(--brand)" }}
                        ></i>
                        {taskList?.ProjectName || "N/A"} |{" "}
                      </span>
                      <span
                        className="w-s"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          whiteSpace: "nowrap",
                        }}
                        title="Assigned By"
                        onClick={() =>
                          history.push(`/Profile/${taskList?.AssignToUserGUID}`)
                        }
                      >
                        {taskList.AssignToProfileImage && (
                          <img
                            src={
                              taskList.AssignToProfileImage ||
                              "images/placeholder_profile.png"
                            }
                            onError={(e) =>
                              (e.target.src = "/images/placeholder_profile.png")
                            }
                            style={{
                              width: "20px",
                              height: "20px",
                              borderRadius: "50%",
                            }}
                          />
                        )}
                        {taskList.AssignToName || "N/A"}
                      </span>

                      <span style={{ color: isOverdue ? "var(--red)" : "inherit" }}>
                        <i
                          className="fa-solid fa-flag"
                          style={{ marginRight: "3px" }}
                        ></i>
                        Due On: {fmtDate(taskList?.DueDate)}{" "}
                        {isOverdue && (
                          <span style={{ marginLeft: "4px", color: "var(--red)" }}>
                            ⚠ Overdue
                          </span>
                        )}
                      </span>
                    </div>
                    {taskList?.ParentTaskNumber && (
                      <span
                        title="Parent Task"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          fontSize: "13px",
                          color: "var(--muted)",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          marginTop: "3px",
                        }}
                      >
                        <strong style={{ color: "var(--txt)", fontSize: "13px" }}>
                          Parent Task Id:
                        </strong>
                        <span>
                          {taskList?.ParentTaskNumber || "—"}
                        </span> |
                        <strong style={{ color: "var(--txt)", fontSize: "13px" }}>
                          Parent Task Name:
                        </strong>
                        {taskList?.ParentTaskGuid ? (
                          <span>
                            <Link to={`/Project/Task/${taskList?.ParentTaskGuid}`}>
                              {taskList?.ParentTaskName || "—"}
                            </Link>
                          </span>
                        ) : (
                          <span>
                            {taskList?.ParentTaskName || "—"}
                          </span>
                        )}
                      </span>
                    )}
                  </div>

                  {/* ACTIONS + WORKFLOW */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-end",
                      gap: "8px",
                      flexShrink: 0,
                    }}
                  >
                    <div className="qa-drop" style={{ position: "relative", display: "flex", gap: "7px" }}>

                      <div className="bt-move-wrap" style={{ position: "relative" }}>
                        {console.log((userDetails?.EmpId), "userDetails?.EmpId")}
                        {console.log(allProject[0]?.ManagerId, "allProject[0]?.ManagerIdd")}
                        <button
                          className="bt-move-btn"
                          disabled={ !createProject || (userDetails?.EmpId !== allProject[0]?.ManagerId)}

                          onClick={(e) => {
                            e.stopPropagation();
                            if (sprintDropdownTaskId === taskList.Id) {
                              setSprintDropdownTaskId(null);
                            } else {
                              const projectData = allProject.find(p => p.Id === taskList.ProjectId);
                              setSelectedProjectData(projectData);
                              setSprintDropdownTaskId(taskList.Id);
                            }
                          }}
                          title="Move to Sprint"
                        >
                          <i className="fa-solid fa-arrow-right-to-bracket" style={{ fontSize: "11px" }}></i> {taskList?.SprintName ? taskList.SprintName : "Backlog"}
                          <i className="fa-solid fa-chevron-down" style={{ fontSize: "8px" }}></i>
                        </button>

                        {sprintDropdownTaskId === taskList.Id && (
                          <div className="sprint-pick-dd open"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <div style={{ padding: "6px 12px", fontSize: "11px", color: "var(--muted)", fontWeight: 600, borderBottom: "1px solid var(--border)" }}>
                              Move to Sprint
                            </div>

                            {/* Move to Backlog */}
                            {Number(taskList.SprintId) !== 0 && (
                              <div
                                style={{ padding: "8px 14px", cursor: "pointer", fontSize: "13px", display: "flex", alignItems: "center", gap: "8px" }}
                                className="sprint-drop-item"
                                onMouseEnter={e => e.currentTarget.style.background = "var(--brand-soft, #fef2f0)"}
                                onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                                onClick={() => {
                                  setIsSprintModal(true);
                                  setMoveSprint({ ...taskList, targetSprint: { Id: 0, SprintName: "Backlog", SprintNumber: "" } });
                                  setSprintDropdownTaskId(null);
                                }}
                              >
                                <span style={{ width: "8px", height: "8px", borderRadius: "50%", background: "#f59e0b", flexShrink: 0, display: "inline-block" }}></span>
                                <span>
                                  <span style={{ fontSize: "10px", color: "var(--muted)", display: "block" }}>Backlog</span>
                                  Move to Backlog
                                </span>
                              </div>)}
                            {/* Active Sprint */}
                            {selectedProjectData?.ProjectSprints?.ActiveSprint &&
                              Number(selectedProjectData.ProjectSprints.ActiveSprint.Id) !== Number(taskList.SprintId) && (
                                <div
                                  style={{ padding: "8px 14px", cursor: "pointer", fontSize: "13px", display: "flex", alignItems: "center", gap: "8px" }}
                                  className="sprint-drop-item"
                                  onMouseEnter={e => e.currentTarget.style.background = "var(--brand-soft, #fef2f0)"}
                                  onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                                  onClick={() => {
                                    setIsSprintModal(true);
                                    setMoveSprint({ ...taskList, targetSprint: selectedProjectData.ProjectSprints.ActiveSprint });
                                    setSprintDropdownTaskId(null);
                                  }}
                                >
                                  <span style={{ width: "8px", height: "8px", borderRadius: "50%", background: "#22c55e", flexShrink: 0, display: "inline-block" }}></span>
                                  <span>
                                    <span style={{ fontSize: "10px", color: "var(--muted)", display: "block" }}>Active Sprint</span>
                                    {selectedProjectData.ProjectSprints.ActiveSprint.SprintName}
                                  </span>
                                </div>
                              )}

                            {/* Planning Sprints */}
                            {selectedProjectData?.ProjectSprints?.PlanningSprint?.length > 0 &&
                              selectedProjectData.ProjectSprints.PlanningSprint
                                .filter(sprint => Number(sprint.Id) !== Number(taskList.SprintId))
                                .map((sprint) => (
                                  <div
                                    key={sprint.Id}
                                    style={{ padding: "8px 14px", cursor: "pointer", fontSize: "13px", display: "flex", alignItems: "center", gap: "8px" }}
                                    onMouseEnter={e => e.currentTarget.style.background = "var(--brand-soft, #fef2f0)"}
                                    onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                                    onClick={() => {
                                      setIsSprintModal(true);
                                      setMoveSprint({ ...taskList, targetSprint: sprint });
                                      setSprintDropdownTaskId(null);
                                    }}
                                  >
                                    <span style={{ width: "8px", height: "8px", borderRadius: "50%", background: "#3b82f6", flexShrink: 0, display: "inline-block" }}></span>
                                    <span>
                                      <span style={{ fontSize: "10px", color: "var(--muted)", display: "block" }}>Planning Sprint</span>
                                      {sprint.SprintName}
                                    </span>
                                  </div>
                                ))
                            }

                            {/* Agar koi sprint nahi */}
                            {!selectedProjectData?.ProjectSprints?.ActiveSprint &&
                              !selectedProjectData?.ProjectSprints?.PlanningSprint?.length && (
                                <div style={{ padding: "10px 14px", fontSize: "13px", color: "var(--muted)" }}>
                                  No sprints available
                                </div>
                              )}
                          </div>
                        )}

                        {(() => {
                          const hasActive = selectedProjectData?.ProjectSprints?.ActiveSprint &&
                            Number(selectedProjectData.ProjectSprints.ActiveSprint.Id) !== Number(taskList.SprintId);
                          const hasPlanning = selectedProjectData?.ProjectSprints?.PlanningSprint?.some(
                            s => Number(s.Id) !== Number(taskList.SprintId)
                          );
                          const hasAnySprint = selectedProjectData?.ProjectSprints?.ActiveSprint ||
                            selectedProjectData?.ProjectSprints?.PlanningSprint?.length;
                          if (hasAnySprint && !hasActive && !hasPlanning) {
                            return (
                              <div style={{ padding: "10px 14px", fontSize: "13px", color: "var(--muted)" }}>
                                Task is already in the only available sprint
                              </div>
                            );
                          }
                          return null;
                        })()}
                      </div>

                      <button
                        className="btn btn-outline btn-sm"
                        onClick={() => setQaOpen(!qaOpen)}
                      >
                        <i className="fa-solid fa-bolt"></i> Actions{" "}
                        <i
                          className="fa-solid fa-chevron-down"
                          style={{ fontSize: "9px" }}
                        ></i>
                      </button>
                      {qaOpen && (
                        <div className="qa-menu open" style={{ display: "block" }}>
                          <div className="qa-menu-sep"></div>
                          <div
                            className="qa-menu-item"
                            onClick={() => {
                              setEditTaskDetails(taskList);
                              setDetailPageMode(false);
                              setModalOpen(true);
                              setParentId(0);
                              setTaskCopy(true);
                              setProjectId(taskList?.ProjectId);
                              setQaOpen(false);
                              setActiveTab(0);
                            }}
                          >
                            <i className="fa-solid fa-copy text-brand"></i>{" "}
                            Clone Task
                          </div>
                          <div className="qa-menu-sep"></div>
                          <div
                            className="qa-menu-item danger"
                            onClick={() => {
                              setDelConfirmOpen(true);
                              setQaOpen(false);
                            }}
                          >
                            <i className="fa-solid fa-trash"></i> Delete Task
                          </div>
                        </div>
                      )}
                      <Link
                        to="/Project/Task/List"
                        className="btn-og btn-og-secondary btn-og-sm"
                        style={{ display: "flex", justifyContent: "flex-start" }}
                        title="Back"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-arrow-left"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fillRule="evenodd"
                            d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
                          />
                        </svg>
                      </Link>
                    </div>

                    {/* Workflow progress */}
                    <div>
                      <div className="wf-mini">
                        {STATUSES.map((s, i) => {
                          const cls =
                            i < curIdx
                              ? "wf-done"
                              : i === curIdx
                                ? "wf-cur"
                                : "wf-future";
                          return (
                            <React.Fragment key={i}>
                              <div className={`wf-dot ${cls}`} title={s}>
                                <i
                                  className={`fa-solid ${i < curIdx ? "fa-check" : ICONS[i]}`}
                                  style={{ fontSize: "9px" }}
                                ></i>
                              </div>
                              {i < STATUSES.length - 1 && (
                                <div
                                  className={`wf-sep ${i < curIdx ? "wf-done-sep" : ""}`}
                                ></div>
                              )}
                            </React.Fragment>
                          );
                        })}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "2px 4px",
                          marginTop: "2px",
                        }}
                      >
                        {STATUSES.map((s, i) => {
                          const c =
                            i < curIdx
                              ? "var(--green)"
                              : i === curIdx
                                ? "var(--brand)"
                                : "var(--muted)";
                          return (
                            <React.Fragment key={i}>
                              <div
                                style={{
                                  fontSize: "9px",
                                  fontWeight: 700,
                                  color: c,
                                  textAlign: "center",
                                  minWidth: "26px",
                                }}
                              >
                                {s.split(" ")[0]}
                              </div>
                              {i < STATUSES.length - 1 && (
                                <div style={{ minWidth: "14px" }}></div>
                              )}
                            </React.Fragment>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* TWO COLUMN LAYOUT */}
              <div className="td-grid">
                {/* LEFT COLUMN */}
                <div>
                  {/* Description */}
                  <div className="card mb14">
                    <div className="ch">
                      <h5>Description</h5>
                    </div>
                    <div
                      className="cb"
                      style={{ fontSize: "13px", lineHeight: 1.75, color: "var(--mid)" }}
                    >
                      {taskList.TaskDescription ? (
                        <>
                          <div
                            className="project-task-description"
                            style={{
                              overflow: "hidden",
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: isDescExpanded ? "unset" : 2,
                              lineHeight: "1.75",
                            }}
                            dangerouslySetInnerHTML={{ __html: taskList.TaskDescription }}
                          />
                          {getPlainText(taskList.TaskDescription).length > 100 && (
                            <button
                              className="btn btn-link btn-sm p-0 mt-0"
                              style={{ fontSize: "12px!important", color: "#7E57C2", textDecoration: "none", float: "right", fontWeight: "500" }}
                              onClick={() => setIsDescExpanded(!isDescExpanded)}
                            >
                              {isDescExpanded ? "Read less" : "Read more"}
                            </button>
                          )}
                        </>
                      ) : (
                        <span style={{ color: "var(--muted)", fontStyle: "italic" }}>
                          No description provided.
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="card mb14">
                    <div className="ch">
                      <h5>Update</h5>
                    </div>
                    <div className="cb row">
                      <div className="col-6 pr-0">
                        <label className="fl">Status</label>
                        <select
                          className="fs"
                          style={{ fontSize: "13px", padding: "12px 10px", height: "30px" }}
                          value={selectedStatus}
                          onChange={(e) => {
                            setSelectedStatus(e.target.value);
                            handleStatusUpdate(e.target.value);
                          }}
                        >
                          <option value="">Select Status</option>
                          {taskStatusType?.map((status) => (
                            <option key={status?.Id} value={status?.Id}>
                              {status.Name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-6">
                        <label className="fl">Assigned To</label>
                        <AutoComplete
                          value={selectedAssingToName}
                          suggestions={filteredEmployees}
                          completeMethod={searchEmployee}
                          field="FullName"
                          className="w-100"
                          style={{ height: "30px" }}
                          placeholder="Assign To"
                          itemTemplate={employeeOptionTemplate}
                          onChange={(e) => {
                            setSelectedAssingToName(e.value);
                          }}
                          onSelect={(e) => {
                            handleAssignUpdate(e.value?.Id);
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Sub-tasks */}
                  <div className="card mb14">
                    <div className="ch">
                      <h5>Sub-Tasks</h5>
                      <span
                        className="mla"
                        style={{ fontSize: "12px", color: "var(--muted)" }}
                      >
                        {subTaskList?.length}{" "}
                        {subTaskList?.length > 1 ? "sub-tasks" : "sub-task"}
                      </span>
                      <a
                        className="btn btn-outline btn-sm"
                        style={{ marginLeft: "8px" }}
                        onClick={() => {
                          setEditTaskDetails(taskList);
                          setDetailPageMode(true);
                          setTaskCopy(false);
                          setModalOpen(true);
                          setParentId(taskList?.Id);
                          setProjectId(taskList?.ProjectId);
                          setActiveTab(2);
                        }}
                      >
                        <i className="fa-solid fa-plus"></i> Add Sub-task
                      </a>
                    </div>
                    <div className="cb p0">
                      <div className="subtask-list"

                      >

                        {subTaskList?.map((st) => (
                          <>
                            <div className="subtask-list-box">
                              <i
                                className="fa-solid fa-sitemap"
                                style={{ opacity: 0.3, marginRight: "6px" }}
                              ></i>
                              <Link to={`/Project/Task/Detail/${st?.GUID}`}>
                                <span key={st?.Id}> {st?.TaskTitle}</span>
                              </Link>
                              <div className="sub-task-status">
                                <p className="bg-light-red">{st?.TaskNumber}</p>
                                <p className="bg-light-warning">{st?.AssignToName}</p>
                                <p className="bg-light-success">{st?.StatusName}</p>
                              </div>
                            </div>
                          </>

                        ))}

                      </div>
                    </div>
                  </div>

                  {/* Comments */}
                  <div className="card mb14">
                    <div className="ch">
                      <h5>Comments</h5>
                      <span className="mla text-muted" style={{ fontSize: "12px" }}>
                        {commentList?.length}{" "}
                        {commentList?.length > 1 ? "comments" : "comment"}
                      </span>
                    </div>
                    <div className="cb">
                      <div className="cmt-box">
                        <div className="flex gap8" style={{ alignItems: "flex-start" }}>
                          <Editor
                            className="cmt-ta"
                            value={newComment}
                            onTextChange={(e) => setNewComment(e.htmlValue || "")}
                            style={{ width: "100%", minHeight: "120px" }}
                          />
                        </div>
                        <div
                          className="flex gap6"
                          style={{ justifyContent: "flex-end", marginTop: "7px" }}
                        >
                          <button
                            className="btn btn-ghost btn-sm"
                            onClick={() => setNewComment("")}
                          >
                            Clear
                          </button>
                          <button
                            className="btn btn-brand btn-sm"
                            onClick={() => AddComment()}
                          >
                            <i className="fa-solid fa-paper-plane"></i> Post
                          </button>
                        </div>
                      </div>

                      <div id="cmtList" style={{ marginTop: "22px" }}>
                        {commentList?.length === 0 ? (
                          <div
                            style={{
                              textAlign: "center",
                              color: "var(--muted)",
                              padding: "12px",
                              fontSize: "12.5px",
                            }}
                          >
                            No comments yet
                          </div>
                        ) : (
                          commentList?.map((c, i) => (
                            <div
                              key={c?.Id}
                              className="flex gap8 mb12 pb12"
                              style={{ borderBottom: "1px solid var(--border-lt)" }}
                            >
                              <img
                                src={c?.CommentedByProfileImage}
                                alt={c?.CommentedByFullName}
                                style={{
                                  width: "22px",
                                  height: "22px",
                                  borderRadius: "50%",
                                  objectFit: "cover",
                                }}
                              />
                              <div style={{ flex: 1 }}>
                                <div className="flex ic gap8 mb4">
                                  <span style={{ fontWeight: 700, fontSize: "13px" }}>
                                    {c?.CommentedByFullName}
                                  </span>
                                  <span style={{ fontSize: "11px", color: "var(--muted)" }}>
                                    {fmtDate(c?.ModifiedDate)}{" "}
                                    {new Date(c?.ModifiedDate).toLocaleTimeString([], {
                                      hour: "numeric",
                                      minute: "2-digit",
                                      hour12: true,
                                    })}
                                  </span>
                                </div>
                                <div
                                  className="ql-editor"
                                  style={{
                                    fontSize: "12.5px",
                                    color: "var(--mid)",
                                    lineHeight: 1.6,
                                    padding: 0,
                                  }}
                                  dangerouslySetInnerHTML={{ __html: c?.Comment || "" }}
                                />
                              </div>
                              <div className="task-edit-delete">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pen" viewBox="0 0 16 16">
                                  <path d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001m-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708z" />
                                </svg>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash" viewBox="0 0 16 16">
                                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                  <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                </svg>
                              </div>
                            </div>
                          ))
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12">
                      <div className="card mb14">
                        <div className="ch">
                          <i className="fa-solid fa-clock-rotate-left text-brand"></i>
                          <h5>History</h5>
                        </div>
                        <div className="cb" id="histList">
                          {taskHistoryData.length === 0 ? (
                            <div
                              style={{
                                textAlign: "center",
                                color: "var(--muted)",
                                padding: "12px",
                                fontSize: "12.5px",
                              }}
                            >
                              No history yet
                            </div>
                          ) : (
                            taskHistoryData?.map((c, i) => (
                              <div className="tl" key={c?.Id}>
                                <div className="tl-item">
                                  <div className="tl-dot">
                                    <i className="fa-solid fa-circle-dot"></i>
                                  </div>
                                  <div className="tl-body">
                                    <div className="fs-12">
                                      <div className="flex align-items-center gap-2 ticket-file-attach__items_detail">
                                        <span style={{ fontSize: "14px", fontWeight: "300" }}>
                                          Modified by
                                        </span>
                                        <LazyImage
                                          alt={c?.ModifiedByProfileImage || "User"}
                                          src={
                                            c?.ModifiedByProfileImage ||
                                            "/images/placeholder_profile.png"
                                          }
                                          width="32"
                                        />
                                        <strong>{c?.ModifiedByFullName || "Unknown"}</strong>
                                        <span style={{ fontSize: "14px", fontWeight: "300" }}>
                                          on {fmtDate(c?.ModifiedDate)}{" "}
                                          {new Date(c?.ModifiedDate).toLocaleTimeString([], {
                                            hour: "numeric",
                                            minute: "2-digit",
                                            hour12: true,
                                          })}
                                        </span>
                                      </div>
                                      <br />
                                      {c.HistoryTitle}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* RIGHT COLUMN */}
                <div>
                  {/* Details card */}
                  <div className="card mb14">
                    <div className="ch">
                      <h5>Details</h5>
                      <button
                        className="btn btn-outline btn-sm mla"
                        onClick={() => {
                          setEditTaskDetails(taskList);
                          setDetailPageMode(false);
                          setModalOpen(true);
                          setParentId(0);
                          setTaskCopy(false);
                          setProjectId(taskList?.ProjectId);
                          setActiveTab(1);
                        }}
                      >
                        <i className="fa-solid fa-pen"></i> Edit
                      </button>
                    </div>
                    <div className="df-grid">
                      <div className="df-row">
                        <div className="df-lbl">Module</div>
                        <div className="df-val">{taskList.ModuleName || "—"}</div>
                      </div>
                      <div className="df-row">
                        <div className="df-lbl">Sub Module</div>
                        <div className="df-val">{taskList.SubModuleName || "—"}</div>
                      </div>
                      <div className="df-row">
                        <div className="df-lbl">Priority</div>
                        <div className="df-val">{taskList.PriorityName || "—"}</div>
                      </div>
                      <div className="df-row">
                        <div className="df-lbl">Severity</div>
                        <div className="df-val">{taskList.SeverityName || "—"}</div>
                      </div>
                      <div className="df-row">
                        <div className="df-lbl">Segment</div>
                        <div className="df-val">{taskList.SegmentName || "—"}</div>
                      </div>
                      <div className="df-row">
                        <div className="df-lbl">Present Task</div>
                        <div className="df-val">{taskList.TaskTypeName || "—"}</div>
                      </div>
                      <div className="df-row">
                        <div className="df-lbl">Reporter</div>
                        <div
                          className="df-val"
                          style={{ display: "flex", alignItems: "center", gap: "6px" }}
                        >
                          <img
                            src={
                              taskList.ReporterProfileImage ||
                              "/images/placeholder_profile.png"
                            }
                            onError={(e) =>
                              (e.target.src = "/images/placeholder_profile.png")
                            }
                            style={{ width: "20px", height: "20px", borderRadius: "50%" }}
                          />
                          {taskList.ReporterFullName || "—"}
                        </div>
                      </div>
                      <div className="df-row">
                        <div className="df-lbl">Created On</div>
                        <div className="df-val">{fmtDate(taskList?.CreatedDate)}</div>
                      </div>
                      <div className="df-row">
                        <div className="df-lbl">Modified By</div>
                        <div
                          className="df-val"
                          style={{ display: "flex", alignItems: "center", gap: "6px" }}
                        >
                          <img
                            src={
                              taskList.ModifiedNameProfileImage ||
                              "/images/placeholder_profile.png"
                            }
                            onError={(e) =>
                              (e.target.src = "/images/placeholder_profile.png")
                            }
                            style={{ width: "20px", height: "20px", borderRadius: "50%" }}
                          />
                          {taskList.ModifiedName || "—"}
                        </div>
                      </div>
                      <div className="df-row">
                        <div className="df-lbl">Modified On</div>
                        <div className="df-val">{fmtDate(taskList?.ModifiedDate)}</div>
                      </div>
                      <div className="df-row">
                        <div className="df-lbl">Est. Hours</div>
                        <div className="df-val">
                          {taskList.EstimatedHours ? `${taskList.EstimatedHours}h` : "—"}
                        </div>
                      </div>
                      <div className="df-row">
                        <div className="df-lbl">Actual Hours</div>
                        <div className="df-val">
                          {taskList.ActualHours ? `${taskList.ActualHours}h` : "—"}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card mb14">
                    <div className="ch">
                      <i className="fa-solid fa-paperclip text-brand"></i>
                      <h5>Attachments</h5>
                      <button
                        className="btn btn-outline btn-sm mla"
                        onClick={() => setUploadFile(true)}
                      >
                        <i className="fa-solid fa-upload"></i> Upload
                      </button>
                    </div>
                    <div id="attList" className="cb p0">
                      {taskList?.Attachments?.length === 0 && (
                        <p
                          style={{
                            textAlign: "center",
                            color: "var(--muted)",
                            padding: "12px",
                            fontSize: "12.5px",
                          }}
                        >
                          No attachments yet.
                        </p>
                      )}
                      {taskList?.Attachments?.map((ta) => (
                        <div className="att-row" key={ta?.Id}>
                          <i className="fa-solid fa-file-image"></i>
                          <div className="att-info">
                            <div className="screenshot-info">
                              {ta?.DocPath?.split(/[/\\]/).pop()}
                            </div>
                          </div>
                          {console.log("Attachment URL:", ta?.DocPath)}
                          <button
                            className="btn btn-ghost btn-icon btn-sm px-1"
                            onClick={() => {
                              const raw = ta.DocPath.replace(/\\/g, "/");
                              const [pathPart, ...rest] = raw.split("?");
                              const safeUrl = rest.length ? `${pathPart}?${rest.join("?")}` : pathPart;
                              window.open(safeUrl, "_blank");
                            }}
                          // onClick={() =>
                          //   {window.open(ta?.DocPath, "_blank", "noopener,noreferrer"); console.log("Opening attachment:", ta?.DocPath);}
                          // }
                          >
                            <i className="fa-solid fa-download"></i>
                          </button>
                          <button
                            className="btn btn-ghost btn-icon btn-sm text-danger px-1"
                            onClick={() => {
                              setDeleteDocPopup(true);
                              setDeleteDocId(ta?.Id);
                            }}
                          >
                            <i className="fa-solid fa-trash"></i>
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>

                  {isModalOpen && (
                    <AddTask
                      isOpen={isModalOpen}
                      onClose={(e) => onClosePopup(e)}
                      editTaskDetails={editTaskDetails}
                      subTaskProjectId={subTaskProjectId}
                      parentId={parentId}
                      taskCopy={taskCopy}
                      detailPage={detailPageMode}
                      activityType={activeTab}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* DELETE ATTACHMENT CONFIRM */}
      {deleteDocPopup && (
        <div className="dc open">
          <div className="dcb">
            <h6>Delete Attachment</h6>
            <p>Are you sure you want to delete this file?</p>
            <div className="flex gap8" style={{ justifyContent: "flex-end" }}>
              <button
                className="btn btn-outline"
                onClick={() => {
                  setDeleteDocId(0);
                  setDeleteDocPopup(false);
                }}
              >
                Cancel
              </button>
              <button className="btn btn-danger" onClick={() => handleDeleteAttachment()}>
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* UPLOAD FILE MODAL */}
      {uploadFile && (
        <div
          className="modal show"
          id="add-file"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content p-0">
              <div className="modal-header border-0" style={{ padding: "14px 18px 0" }}>
                <h6 style={{ fontWeight: 700, margin: 0 }}>
                  <i
                    className="fa-solid fa-paperclip text-brand"
                    style={{ marginRight: "6px" }}
                  ></i>
                  Upload Attachment
                </h6>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setDocPathUrl("");
                    setUploadFile(false);
                  }}
                ></button>
              </div>

              <div className="modal-body" style={{ padding: "18px" }}>
                <div
                  onDragOver={handleDragOver}
                  onDragLeave={handleDragLeave}
                  onDrop={handleDrop}
                  onClick={() => document.getElementById("file-upload").click()}
                  style={{
                    border: `2px dashed ${isDragging ? "var(--brand)" : "var(--border-lt)"}`,
                    borderRadius: "10px",
                    background: isDragging
                      ? "rgba(var(--brand-rgb, 99,102,241),0.05)"
                      : "var(--bg-lt, #f9f9fb)",
                    padding: "32px 20px",
                    textAlign: "center",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                  }}
                >
                  <i
                    className="fa-solid fa-cloud-arrow-up"
                    style={{
                      fontSize: "32px",
                      color: isDragging ? "var(--brand)" : "var(--muted)",
                      marginBottom: "10px",
                      display: "block",
                      transition: "color 0.2s",
                    }}
                  ></i>
                  <p
                    style={{
                      margin: "0 0 4px",
                      fontWeight: 600,
                      fontSize: "13.5px",
                      color: "var(--txt)",
                    }}
                  >
                    {isDragging ? "Drop files here" : "Drag & drop files here"}
                  </p>
                  <p style={{ margin: 0, fontSize: "12px", color: "var(--muted)" }}>
                    or{" "}
                    <span style={{ color: "var(--brand)", fontWeight: 600 }}>browse</span>{" "}
                    to choose a file
                  </p>
                  <p style={{ margin: "8px 0 0", fontSize: "11px", color: "var(--muted)" }}>
                    Supported: PDF, DOC, XLS, PPT, ZIP, JPG, PNG…
                  </p>
                  <input
                    type="file"
                    id="file-upload"
                    style={{ display: "none" }}
                    onChange={handleFileChangeDoc}
                    accept=".doc,.docx,.pdf,.xls,.xlsx,.csv,.zip,.rar,.ppt,.pptx,.jpg,.jpeg,.png,.mp3,.mp4"
                  />
                </div>

                {docPathUrl && (
                  <div
                    style={{
                      marginTop: "12px",
                      padding: "10px 12px",
                      background: "var(--bg-lt, #f4f4f8)",
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      fontSize: "12.5px",
                    }}
                  >
                    <i
                      className="fa-solid fa-file-circle-check"
                      style={{ color: "var(--green, #22c55e)" }}
                    ></i>
                    <span style={{ flex: 1, wordBreak: "break-all", color: "var(--txt)" }}>
                      {docPathUrl?.split(/[/\\]/).pop()}
                    </span>
                    <button
                      className="btn btn-ghost btn-icon btn-sm text-danger px-1"
                      onClick={() => setDocPathUrl("")}
                      title="Remove"
                    >
                      <i className="fa-solid fa-xmark"></i>
                    </button>
                  </div>
                )}
              </div>

              <div className="col-md-12">
                <div className="btns-grp">
                  <button
                    type="button"
                    className="cancelbtn-click"
                    onClick={() => {
                      setDocPathUrl("");
                      setUploadFile(false);
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    disabled={!docPathUrl}
                    type="button"
                    className="savebtn-click btn-purple rounded"
                    onClick={() => taskAttachmentAdd()}
                  >
                    <i className="fa-solid fa-upload" style={{ marginRight: "5px" }}></i>
                    Upload
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* DELETE TASK CONFIRM */}
      {delConfirmOpen && (
        <div
          className="modal show"
          id="delete-task-confirm"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content delete-holiday">
              <div className="modal-header">
                <img
                  src="/images/org-img/leave/popup-backimg.png"
                  className="backimg"
                />
                <div className="img">
                  <img src="/images/org-img/leave/trash.png" />
                </div>
              </div>
              <div className="modal-body text-center">
                <p>Are you sure you want to delete this task?</p>
              </div>
              <div className="modal-footer m-auto">
                <button
                  type="button"
                  className="cancelbtn-click"
                  onClick={() => {
                    setDelConfirmOpen(false);
                    setDeletedTaskId(0);
                  }}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="deletebtn-click"
                  onClick={() => taskDelete()}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}


      {/* Email Confirmation */}
      {isSprintModal && (
        <div
          className="modal show"
          id="delete-task-confirm"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content delete-holiday">
              <div className="modal-header">
                <img
                  src="/images/org-img/leave/popup-backimg.png"
                  className="backimg"
                />
                <div className="img">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-send" viewBox="0 0 16 16">
                    <path d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576zm6.787-8.201L1.591 6.602l4.339 2.76z" />
                  </svg>
                </div>
              </div>
              <div className="modal-body text-center">
                <p>Are you sure you want to move to this sprint?</p>
              </div>
              <div className="modal-footer m-auto">
                <button
                  type="button"
                  className="cancelbtn-click"
                  onClick={() => {
                    setIsSprintModal(false);

                  }}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="deletebtn-click"
                  onClick={() => {

                    sendMoveSprint();
                    // Proceed with sending email
                  }}
                >
                  Move To Sprint
                </button>
              </div>
            </div>
          </div>
        </div>
      )}


      {isLoading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
};

export default TashManagementTaskDetails;
